<template>
    <div class="shareholder">
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="financeInfo"
            :currentPage="currentPage"
            @synchronize-btn="handleSynchronize"
            @save-btn="handleSave"
            @add-btn="handleAdd"
            @del-btn="handleDel"
            @row-db-click="rowDBClick"
            @selectChange="selectChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
        </m-pane>
        <OperateDialog ref="odRef" :supplierTab="supplierTab" @refresh="handleSearch" />
    </div>
</template>
<script>
import mPane from '../../../../../components/Table/Index.vue';
import OperateDialog from '../../../manage/keyData/tabs/shareholder/OperateDialog.vue';
import config from './config.js';
import { getTableData, saveShareholderInfo, synShareholderInfo, deleteShareholder } from '../../../../../api/shareholder.js';
import { ABROAD, HKMCTW } from '../../../../../constant/supplierListConstant.js'
export default {
    name: 'Shareholder',
    components: { mPane, OperateDialog },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierCode: ''
                };
            }
        }
    },
    data() {
        return {
            totalData: [],
            config: JSON.parse(JSON.stringify(config)),
            pageTotal: 0,
            loading: false,
            currentPage: 1,
            selected: [],
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            supplierTab_: {}
        };
    },
    computed: {
        overseaFlag() {
            // 开关已开，当主体性质=国外或港澳台
            return this.supplierTab.overseaSwitch && [ABROAD, HKMCTW].includes(this.supplierTab.propertyNature)
        }
    },
    methods: {
        /** 点击查询 调接口，拿table数据 **/
        handleSearch() {
            const params = { supplierCode: this.supplierTab_.supplierCode, ...this.searchParams };
            getTableData(params).then((res) => {
                if (res && res.code === '0') {
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                    this.inputState();
                }
            });
        },
        /** 输入框置灰 **/
        inputState() {
            for (let i = 0; i < this.totalData.length; i++) {
                if (this.totalData[i].stockholderType === '1') {
                    this.totalData[i].disableProps = ['idCard'];
                }
            }
        },
        /** 保存 **/
        handleSave() {
            const infoFileRequestList = [];
            let count = 0;
            for (let i = 0; i < this.selected.length; i++) {
                if (this.selected[i].stockholderType === '1') {
                    count++;
                    infoFileRequestList.push({ id: this.selected[i].id, unifiedCreditCode: this.selected[i].unifiedCreditCode });
                } else if (this.selected[i].stockholderType === '2') {
                    if (!this.selected[i].idCard) {
                        this.$message.warning('请完善身份证信息！');
                        break;
                    } else {
                        count++;
                        infoFileRequestList.push({ id: this.selected[i].id, idCard: this.selected[i].idCard });
                    }
                }
            }
            if (count === this.selected.length) {
                saveShareholderInfo({ infoFileRequestList: infoFileRequestList }).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('保存成功');
                        this.handleSearch();
                    }
                });
            }
        },
        /** 同步 **/
        handleSynchronize() {
            const synParams = { supplierCode: this.supplierTab.supplierCode, supplierName: this.supplierTab.supplierName };
            this.config.buttonList[1].loading = true;
            synShareholderInfo(synParams).then(res => {
                this.config.buttonList[1].loading = false;
                if (res && res.code === '0') {
                    this.$message.success('同步信息成功');
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                    this.inputState();
                }
            }).then(e => { this.config.buttonList[1].loading = false; });
        },
        handleAdd() {
            this.$refs.odRef && this.$refs.odRef.open()
        },
        handleDel() {
            if (!this.selected.length) {
                return this.$message({ type: 'warning', message: '请先选择数据！' });
            }
            this.$confirm('请确认是否删除所选数据?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteShareholder(this.selected.map(v => v.id)).then(res => {
                    if (res && +res.code === 0) {
                        this.$message({ type: 'success', message: '删除成功!' });
                        this.handleSearch();
                    }
                });
            }).catch(() => {
                // this.$message({ type: 'info', message: '已取消删除' });
            });
        },
        rowDBClick(row) {
            if (this.overseaFlag) {
                this.$refs.odRef.open(row)
            }
        },
        selectChange(data) {
            this.selected = [].concat(data);
        },
        pageChange(data) {
            this.searchParams.pageNo = data;
            this.handleSearch();
        },
        sizeChange(data) {
            this.$set(this.searchParams, 'pageSize', data);
            this.$set(this.searchParams, 'pageNo', 1);
            this.handleSearch();
        }
    },
    watch: {
        supplierTab: {
            handler(nVal) {
                if (Object.keys(nVal).length) {
                    if (this.overseaFlag) {
                        this.config.table.tableCut = false
                        this.config.buttonList = this.config.buttonList.filter(item => ['add', 'del'].includes(item.event))
                    } else {
                        this.config.table.tableCut = true
                        this.config.buttonList = this.config.buttonList.filter(item => ['save', 'synchronize'].includes(item.event))
                    }
                    this.supplierTab_ = JSON.parse(JSON.stringify(nVal));
                    this.handleSearch();
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="less">
.shareholder {
}
</style>
